import React from 'react';
import CONSTANTS from 'signer-app/signature-modal/constants';

export const MAX_FILE_SIZE = 40 * 1000 * 1000; // 40 MB

export const CONTRAST_MID_VALUE =
  (CONSTANTS.CONTRAST_MAX_THRESHOLD + CONSTANTS.CONTRAST_MIN_THRESHOLD) / 2;

export const FILE_UPLOAD_REGEX = /image\/(png|jpg|jpeg|bmp|gif)/;

export const DROPZONE_ACCEPT_CONFIG: Record<string, string[]> = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/bmp': ['.bmp'],
  'image/gif': ['.gif'],
  'image/heic': ['.heic'],
  'image/heif': ['.heic'],
  'image/webp': ['.webp'],
};

/**
 * Adds a full stop for punctuation so that screen reader can announce it more naturally
 */
export const VisuallyHiddenFullStop = () => (
  <span className="visuallyHidden">.</span>
);
